"use client";

import Link from "next/link";
import classes from "./side-nav-link.module.css";
import { usePathname } from "next/navigation";

export default function SideNavLinkMain({ href, children }) {
  const path = usePathname();

  const buttonStyle =
    "md:text-md hover:text-blue-500 transition duration-300 font-medium";

  return (
    <Link
      className={path.startsWith(href) ? classes.active : buttonStyle}
      href={href}
    >
      {children}
    </Link>
  );
}
